module.exports = __webpack_public_path__ + "img/4679a63ad474b1afbf34e34187b75023.png";